import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

export const getPurchaseInvoices = async () => {
  const response = await axiosInstance.get('Purchase/get-purchase-invoices');
  return response.data;
};

export const getPurchaseInvoiceById = async (id) => {
  const response = await axiosInstance.get(`Purchase/get-purchase-invoice/${id}`);
  return response.data;
};

export const addPurchaseInvoice = async (purchaseInvoice) => {
  const response = await axiosInstance.post('Purchase/add-purchase-invoice', purchaseInvoice);
  return response.data;
};

export const updatePurchaseInvoice = async (purchaseInvoice) => {
  const response = await axiosInstance.put('Purchase/update-purchase-invoice', purchaseInvoice);
  return response.data;
};

export const deletePurchaseInvoice = async (id) => {
  await axiosInstance.delete(`Purchase/delete-purchase-invoice/${id}`);
};

export const getPurchaseInvoicesBySupplier = async (supplierId) => {
  const response = await axiosInstance.get(`Purchase/by-supplier/${supplierId}`);
  return response.data;
};